import React from 'react';
import PropTypes from 'prop-types';

import BaseSelectField from '../BaseSelectField';

const ReduxSelectField = ({
  input,
  options,
  multi,
  meta: { touched, error },
  disabled,
  noErrorMessage,
  isCreatable,
  ...props
}) => {
  const handleChange = option => {
    if (disabled) return null;
    let value;
    if (Array.isArray(option)) {
      value = option.length ? option.map(o => o.value) : null;
    } else {
      value = option ? option.value : null;
    }
    return input.onChange(value);
  };

  const mobileChange = e => {
    if (disabled) return;
    if (e && e.target && e.target.value) {
      let value = e.target.value;
      if (value === 'true') {
        value = true;
      } else if (value === 'false') {
        value = false;
      }
      input.onChange(value);
    }
  };

  let value;
  if (Array.isArray(input.value)) {
    value = [];
    input.value.forEach(inputOption => {
      value.push(options.find(option => option.value === inputOption)); // eslint-disable-line
    });
  } else {
    // 对于 creatable 模式，如果 value 不在 options 中，则创建一个新的 option
    const foundOption = options.find(option => option.value === input.value);
    if (foundOption) {
      value = foundOption;
    } else if (isCreatable && input.value) {
      // 如果是 creatable 模式且有值，创建一个新 option
      value = { label: input.value, value: input.value };
    } else {
      value = foundOption;
    }
  }

  return (
    <BaseSelectField
      {...props}
      {...input}
      additionalClass
      name={input.name}
      value={value}
      error={touched && error}
      onChange={handleChange}
      onMobileChange={mobileChange}
      onBlur={() => input.onBlur(input.value)}
      blurInputOnSelect={false}
      options={options}
      isMulti={multi}
      searchable
      isCreatable={isCreatable}
      disabled={disabled || !options.length}>
      <span className="ReduxSelectField__error-text">{!options.length && noErrorMessage}</span>
      <span className="ReduxSelectField__error-text">{touched && error}</span>
    </BaseSelectField>
  );
};

ReduxSelectField.propTypes = {
  input: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool.isRequired,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  }).isRequired,
  disabled: PropTypes.bool,
  multi: PropTypes.bool,
  noErrorMessage: PropTypes.string,
  isCreatable: PropTypes.bool,
};

ReduxSelectField.defaultProps = {
  disabled: false,
  multi: false,
  noErrorMessage: '',
  isCreatable: false,
};

export default ReduxSelectField;
